import { render, staticRenderFns } from "./system_competition_management.vue?vue&type=template&id=0b4ea9ee&"
import script from "./system_competition_management.vue?vue&type=script&lang=js&"
export * from "./system_competition_management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports